// アプリ全体で共通利用する状態ラベル定義
export const MODE = import.meta.env.VITE_MODE;

//スクリーンステートとして管理
export const SC_STATE = {
  BI_TOKEN_FETCHING: 'BI_TOKEN_FETCHING',           // Power BI トークン取得中
  BI_TOKEN_REFETCHING: 'BI_TOKEN_REFETCHING',       // Power BI トークン再取得中
  AUTHENTICATED: 'AUTHENTICATED',                   // 認証済み状態
  ERR_PERMANENT: 'ERR_PERMANENT',               // 永続的なエラー状態
  ERR_NONPERMANENT: 'ERR_NONPERMANENT',         // 一時的なエラー状態
  BI_ERR_PERMANENT: 'BI_ERR_PERMANENT',         // Power BI 永続的エラー
  BI_ERR_NONPERMANENT: 'BI_ERR_NONPERMANENT',   // Power BI 一時的エラー
  // 必要に応じて追加
};

//独自URL(カスタムなURL)として管理
export const C_URLS = {
  ROOT_LOGIN: import.meta.env.VITE_ROOT_LOGIN_URL,   // Power BI 一時的エラー
  BITOKEN_API: import.meta.env.VITE_API_URL + '/credential/bitoken',   // Power BI 一時的エラー
  // 必要に応じて追加
};

//独自ログワーディングとして管理
export const C_LOGWORDING = {
  LOG001_: 'ログ',   // Power BI 一時的エラー
  // 必要に応じて追加
};

//独自エラーワーディングとして管理
export const C_ERRWORDING = {
  ERR000: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR001: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR002: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR003: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR004: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR005: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR006: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR007: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR008: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR009: 'ライセンス情報の読み込みに失敗しました',   // Power BI 一時的エラー
  ERR010: 'ライセンス情報の読み込みに失敗しました',   // ライセンス文表示失敗
  // 必要に応じて追加
};